import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { VerifyCodeDTO } from 'config/types'
import { VerifyResponse } from 'config/types/register'

interface CodeVerifyState extends VerifyResponse {}

const initialState: CodeVerifyState = {
  status: 0,
  message: '',
  data: {},
  user_data: null,
}

const userCodeSlice = createSlice({
  name: 'userCode',
  initialState,
  reducers: {
    updateUserCode: (state, action: PayloadAction<VerifyCodeDTO>) => {
      return { ...state, ...action.payload }
    },
  },
})

export const { updateUserCode } = userCodeSlice.actions
export default userCodeSlice.reducer
